var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center pa-2 pt-5",staticStyle:{"width":"100%"}},[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }